<template>
    <div class="row d-print-none" v-if="print">
       <div class="col col-12 text-right">
          <div class="print-button my-2">
            <button
              class="btn btn-print btn-success"
              :class="{ 'btn-loading': loadingPrint }"
              @click="printInventory"
            >
              <span class="btn-print__spinner" v-if="loadingPrint"
                ><ProgressSpinner
                  style="width: 18px; height: 18px"
                  stroke-width="5"
              /></span>
              <span v-if="!loadingPrint">Imprimir</span>
            </button>
          </div>
        </div>
    </div>
    <div class="row">
      <div class="col-12">
        <DataTable
          :value="confined_spaces"
          :lazy="true"
          :paginator="true"
          :rows="per_page"
          :rows-per-page-options="[10, 25, 50]"
          :total-records="inventory_total_confined_spaces"
          :loading="loading"
          :row-hover="true"
          @page="onPage($event)"
          @sort="onSort($event)"
          ref="datatable"
          data-key="id"
          class="p-datatable-gridlines p-datatable-sm table-striped"
        >
          <template #empty> Nenhum espaço confinado</template>
          <template #loading> Carregando</template>
          <ColumnGroup type="header">
            <Row>
              <Column class="text-center bg-primary text-light" header="#" />
              <Column class="text-center bg-primary text-light" header="ID" header-class="bg-light" />
              <Column class="text-center bg-primary text-light" header="Tag&nbsp;Ambra" />
              <Column class="text-center bg-primary text-light" header="Tag&nbsp;E.C." />
              <Column class="text-center bg-primary text-light" header="Tipo&nbsp;E.C." />
              <Column class="text-center bg-primary text-light" header="Nome&nbsp;E.C." />
              <Column class="text-center bg-primary text-light" header="Nº&nbsp;De&nbsp;BVs" />
              <Column class="text-center bg-primary text-light" header="Necessita&nbsp;Ponto&nbsp;De&nbsp;Resgate" />
              <Column class="text-center bg-primary text-light" header="Possui&nbsp;Ficha&nbsp;Técnica" />
              <Column class="text-center bg-primary text-light" header="Ficha&nbsp;Técnica&nbsp;Atualizada" />
              <Column class="text-center bg-primary text-light" header="Completamente&nbsp;Adequada&nbsp;Em&nbsp;Campo" />
              <Column class="text-center bg-primary text-light" header="Setor" header-class="bg-light" />
              <Column class="text-center bg-primary text-light" header="Área" />
              <Column class="text-center bg-primary text-light" header="Complemento" header-class="bg-light" />
              <Column class="text-center bg-primary text-light d-print-none" header="Ações" header-class="bg-light" />
            </Row>
          </ColumnGroup>
          <Column class="text-center">
            <template #body="slotProps">
              {{ slotProps.index + 1 }}
            </template>
          </Column>
          <Column class="text-center" field="id"></Column>
          <Column class="text-center" field="ambra_tag"></Column>
          <Column class="text-center" field="confined_space_tag"></Column>
          <Column class="text-center" field="confined_space_type.name"></Column>
          <Column class="text-center" field="name"></Column>
          <Column class="text-center" field="bvs_amount"></Column>
          <Column class="text-center" field="is_rescue_point_required"></Column>
          <Column class="text-center" field="has_datasheet"></Column>
          <Column class="text-center" field="is_datasheet_updated"></Column>
          <Column class="text-center" field="is_completely_suitable"></Column>
          <Column class="text-center" header="Setor" field="sector_name"></Column>
          <Column class="text-center" header="Área" field="area_name"></Column>
          <Column class="text-center" header="Complemento" field="complement_name"></Column>
          <Column class="text-center d-print-none">
            <template #body="slotProps" v-if="authenticated_user !== 'Cliente somente leitura'">
              <button
                class="btn btn-link"
                v-tooltip="'Selecione o espaço confinado e adicione no mapa'"
                @click="selectConfinedSpace(slotProps.index)"
              >
                <font-awesome-icon
                  :icon="['fas', 'map-marked-alt']"
                ></font-awesome-icon>
              </button>
              <button
                class="btn btn-link"
                v-tooltip="'Clique para editar'"
                @click="editConfinedSpace(slotProps.index)"
              >
                <font-awesome-icon
                  :icon="['fas', 'pen-alt']" style="cursor: pointer"
                ></font-awesome-icon>
              </button>
              <button
                class="btn btn-link"
                v-tooltip="'Clique para excluir'"
                @click="deleteConfinedSpace(slotProps.index)"
              >
                <font-awesome-icon
                  :icon="['fas', 'trash-alt']" style="cursor: pointer"
                ></font-awesome-icon>
              </button>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
</template>

<script>
  import { computed, onMounted, ref } from 'vue'

  import { useRoute } from 'vue-router'

  import { useStore } from 'vuex'
  import useConfinedSpaces from '@/modules/ConfinedSpace.js'
  import { format } from 'date-fns'
  import Column from 'primevue/column'
  import ColumnGroup from 'primevue/columngroup'
  import DataTable from 'primevue/datatable'
  import Row from 'primevue/row'
  import ProgressSpinner from 'primevue/progressspinner'
  import useSwal from '@/modules/Swal.js'

  export default {
    components: {
      Column,
      ColumnGroup,
      DataTable,
      Row,
      ProgressSpinner,
    },
    setup() {
      const store = useStore()
      const route = useRoute()
      const selected_order_of_service = computed(() => store.getters.selected_order_of_service)
      const authenticated_user = computed(() => store.getters.authenticated_user.user_profile.name)
      const page = ref(1)
      const per_page = ref(10)
      const datatable = ref(null)
      const {
        filtered_confined_spaces,
        inventory_total_confined_spaces,
        listInventory,
        destroyConfinedSpace,
        loading,
      } = useConfinedSpaces()
      const { showConfirmDeletionSwal } = useSwal()

      const onPage = event => {
        page.value = event.page + 1
        per_page.value = event.rows

        listInventory(selected_order_of_service.value.id, page.value, per_page.value, 12)
      }

      onMounted(async () => {
        listInventory(selected_order_of_service.value.id, page.value, per_page.value, 12)
      })

      const print = route.name == 'confined-space-print'

      return {
        datatable,
        loading,
        confined_spaces: filtered_confined_spaces,
        destroyConfinedSpace,
        onPage,
        inventory_total_confined_spaces,
        per_page,
        page,
        showConfirmDeletionSwal,
        print,
        route,
        listInventory,
        selected_order_of_service,
        authenticated_user
      }
    },
    data() {
      return {
        loadingPrint: false,
      }
    },
    methods: {
      selectConfinedSpace(item) {
        const confined_space = this.confined_spaces[item]
        const risk_analysis_id = confined_space?.risk_analyses[0]?.id
        const marker_selected = {
          id: risk_analysis_id,
          confined_space_id: confined_space?.id,
          created_at: format(new Date(), 'dd/MM/yyyy H:m:s'),
        }

        localStorage.setItem(
          'selected_confined_space_table',
          JSON.stringify(marker_selected),
        )
      },

      editConfinedSpace(item) {
        const confined_space = this.confined_spaces[item]

        this.$router.push({
          name: 'confined-space-edit',
          params: { id: confined_space.id }
        })
      },

      deleteConfinedSpace(item) {
        const confined_space = this.confined_spaces[item]

        this.showConfirmDeletionSwal()
          .then(response => {
            if (response.isConfirmed) {
              this.destroyConfinedSpace(confined_space)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },

      printInventory() {
        if (this.loadingPrint) return

        this.loadingPrint = true

        Promise.all(
          Array.from(document.images)
            .filter((img) => !img.complete)
            .map(
              (img) =>
                new Promise((resolve) => {
                  img.onload = img.onerror = resolve
                }),
            ),
        ).then(() => {
          console.log('images finished loading')
          this.loadingPrint = false
          window.print()
        })
      },
    },
    watch: {
      '$route.name': function (name) {
        this.print = name == 'confined-space-print'
      },

      selected_order_of_service() {
        this.listInventory(
          this.selected_order_of_service.id,
          this.page,
          this.per_page,
          12
        )
      }
    }
  }

</script>

<style type="text/css" media="print">
  @page {
    size: landscape !important;
  }
</style>
